import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';

const AccordionLayout = (props) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (event, isExpanded) => {
    setExpanded(isExpanded);
  };

  return (
    <div>
      <Accordion
        expanded={expanded}
        onChange={handleChange}
        sx={{
          border: '1px solid #f3f7f5',
          boxShadow: expanded ? 2 : 1,
          '&:not(.Mui-expanded)': {
            boxShadow: 'none',
          },
          transition: 'box-shadow 0.3s ease',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="span">{props.title}</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ height: 'auto' }}>
          <Typography>
            {props.detail}
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default AccordionLayout;
